export default class TTLStorage {
  private readonly storage: Storage;

  private readonly prefix: string;

  constructor(storage = localStorage, prefix = 'authorify-') {
    this.storage = storage;
    this.prefix = prefix;
  }

  set(key: string, value: any, ttl: number) {
    const record = {
      value,
      expiresAt: Date.now() + ttl,
    };
    this.storage.setItem(this.fullKey(key), JSON.stringify(record));
  }

  get(key) {
    const raw = this.storage.getItem(this.fullKey(key));
    if (raw === null) return null;

    try {
      const { value, expiresAt } = JSON.parse(raw);
      if (expiresAt && Date.now() > expiresAt) {
        this.storage.removeItem(this.fullKey(key));
        return null;
      }
      return value;
    } catch {
      this.storage.removeItem(this.fullKey(key));
      return null;
    }
  }

  remove(key) {
    this.storage.removeItem(this.fullKey(key));
  }

  clear() {
    const now = Date.now();
    const keysToCheck = [];

    for (let i = 0; i < this.storage.length; i++) {
      const fullKey = this.storage.key(i);
      if (fullKey && fullKey.startsWith(this.prefix)) {
        keysToCheck.push(fullKey);
      }
    }

    for (const fullKey of keysToCheck) {
      const raw = this.storage.getItem(fullKey);
      if (!raw) {
        this.storage.removeItem(fullKey);
        return;
      }

      let record;
      try {
        record = JSON.parse(raw);
      } catch {
        // remove completely invalid JSON
        this.storage.removeItem(fullKey);
        return;
      }

      const { expiresAt } = record;
      if (typeof expiresAt === 'number' && now > expiresAt) {
        this.storage.removeItem(fullKey);
      }
    }
  }

  private fullKey(key) {
    return `${this.prefix}${key}`;
  }
}
